/**
 * Options to configure a new Toast
 */
export class ToastOptions {
  title: string;
  msg?: string;
  showClose?: boolean;
  timeout?: number;
}

/**
 * Global configuration for all Toasts
 */
export class ToastConfig {
  showClose?: boolean;
  timeout?: number;
}
